import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ThreeDots } from 'react-bootstrap-icons';

export const ClientsList = ({ clients, totalPages, navigate, pageIndex, setPageIndex }) => {
    return (
        <div>
            <div className="table-responsive">
                <table className="w-100 table table-hover">
                    <thead>
                        <tr>
                            <th>Клиент</th>
                            <th>Телефон</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients && clients.length > 0 ?
                            clients.map(client =>
                                <tr key={client.id}>
                                    <td>
                                        <div>{client.lastName} {client.firstName} </div>
                                        <div>{client.patronymic}</div>
                                        <div className="text-muted">{client.email}</div>
                                    </td>
                                    <td style={{
                                        verticalAlign: "middle",
                                    }}>
                                        {client.phone}
                                    </td>
                                    <td style={{
                                        verticalAlign: "middle",
                                        textAlign: "right"
                                    }}>
                                        <UncontrolledDropdown>
                                            <DropdownToggle color="light" >
                                                <ThreeDots className='' size='14' />
                                            </DropdownToggle>
                                            <DropdownMenu container="body">
                                                <DropdownItem onClick={() => navigate('edit/' + client.id)}>Изменить</DropdownItem>

                                                <DropdownItem onClick={() => navigate('details/' + client.id)}>Подробнее</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </td>
                                </tr>
                            )
                            : <tr><td colSpan={5} className={"text-center"}>Список пуст</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex flex-row justify-content-center align-content-center mt-3 mb-3">
                <div className="btn-group">
                    <button
                        className={pageIndex == 1 ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={() => {
                            if (pageIndex > 1) {
                                setPageIndex(pageIndex - 1)
                            }
                        }}>Назад</button>
                    <button
                        className={(pageIndex == totalPages || totalPages == 0) ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={
                            () => {
                                if (pageIndex <= totalPages) {
                                    setPageIndex(pageIndex + 1)
                                }
                            }}
                    >Вперед</button>
                </div>
            </div>
        </div>
    )
}